module.exports = __webpack_public_path__ + "img/minus.56f4699a.svg";